/* eslint-disable no-console */
import type { NextWebVitalsMetric } from 'next/app';
import { googleAnalyticsClient } from '@app/analytics';
import { trackEvent, EVENTS } from '@app/segment';
import { isServer } from '@app/utils';
import { datadogRum } from '@datadog/browser-rum-slim';

let metrics = {};

const onReportMetric = ({ name, value }: NextWebVitalsMetric) => {
  // Add to metrics object for Segment
  metrics[name] = value;

  // Report to console
  const searchParams = new URLSearchParams(window.location.search);
  const logToConsole = searchParams.get('enableWebVitals') === 'true';

  if (logToConsole) {
    console.table({ name, value });
  }

  // Report metrics individually to Google Analytics
  if (name !== 'INP' && name !== 'TTFB') {
    googleAnalyticsClient.event({
      eventAction: name,
      eventLabel: value,
      eventCategory: 'Core Web Vitals',
      nonInteraction: true,
    });
  }
};

const reportToSegment = () => {
  if (Object.keys(metrics).length > 0) {
    trackEvent(EVENTS.INITIAL_PAGE_PERFORMANCE, metrics);

    metrics = {};
  }
};

const reportWebVitals = (metric: NextWebVitalsMetric): void => {
  switch (metric.name) {
    case 'LCP':
    case 'CLS':
    case 'FID':
    case 'INP':
    case 'TTFB':
      onReportMetric(metric);
      break;
    case 'Next.js-hydration':
      datadogRum.addTiming('app.hydration-complete');
      break;
    case 'Next.js-route-change-to-render':
      datadogRum.addTiming('app.route-change-render-start');
      break;
    case 'Next.js-render':
      datadogRum.addTiming('app.route-change-render-complete');
      break;
    default:
      break;
  }
};

if (!isServer) {
  // Report all available metrics whenever the page is backgrounded or unloaded
  window.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      reportToSegment();
    }
  });

  // Safari does not reliably fire the `visibilitychange` event when the
  // page is being unloaded
  window.addEventListener('pagehide', reportToSegment);
}

export default reportWebVitals;
